<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.user_type_id" class="modal-card-title">Crear Calidad Contractual</p>
          <p v-else class="modal-card-title">Editar Calidad Contractual</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="user_type.name"
              v-model="user_type.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.user_type_id" class="button is-primary" @click="createUserType()">Guardar</button>
          <button v-else class="button is-primary" @click="editUserType()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: [
    "isComponentModalActive",
    "closeBasic",
    "chargeUserTypeList",
    "user_type_id",
  ],
  data() {
    return {
      user_type: {
        name: "",
      },
      isLoading: false,
    };
  },
  created: function () {
    this.isLoading = true;
    if (this.user_type_id) {
      this.chargeUserTypeData().then(() => {
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  },
  methods: {
    createUserType: async function () {
      this.isLoading = true;
      let data = {
        ...this.user_type,
      };
      await this.$http.post(`api/${localStorage.getItem('perfil')}/type_user`, data).then(
        (response) => {
          //Limpia el objeto stablishment
          for (const i in this.user_type) {
            this.user_type[i] = "";
          }
          console.log("POST:", response.body);
          this.chargeUserTypeList();
          this.closeBasic();
          this.toast("Creada calidad contractual", "is-success");
          this.isLoading = false;
        },
        (response) => {
          this.toast("Error al crear calidad contractual", "is-danger");
          this.isLoading = false;
          console.log("error: ", response);
        }
      );
    },
    editUserType: function () {
      this.isLoading = true;
      let data = {
        ...this.user_type,
      };
      this.$http
        .put(`api/${localStorage.getItem('perfil')}/type_user/` + this.user_type_id, data)
        .then(
          (response) => {
            //Limpia el objeto prevition
            for (const i in this.user_type) {
              this.user_type[i] = "";
            }
            console.log("PUT:", response.body);
            this.chargeUserTypeList();
            this.closeBasic();
            this.toast("Editada calidad contractual", "is-success");
            this.isLoading = false;
          },
          (response) => {
            this.toast("Error al editar", "is-danger");
            this.isLoading = false;
            console.log("error: ", response);
          }
        );
    },
    chargeUserTypeData: async function () {
      await this.$http
        .get(`api/${localStorage.getItem('perfil')}/type_user/` + this.user_type_id)
        .then(
          (response) => {
            console.log(response);
            this.user_type.name = response.body.type.name;
          },
          (response) => {
            console.log(response);
          }
        );
    },
  },
};
</script>